<template>
  <m-dialog ref="dlg" :btnsave="false" title="Pilih Anggota">
    <v-container v-if="$vuetify.breakpoint.smAndUp && current_organisasi">
      <v-stepper v-model="step">
        <v-stepper-header>
          <v-stepper-step step="1">
            Pilih Anggota
          </v-stepper-step>
          <v-divider></v-divider>
          <v-stepper-step step="2">
            Konfirmasi
          </v-stepper-step>
          <v-divider></v-divider>
        </v-stepper-header>

        <v-stepper-content step="1">
          <v-card flat>
            <v-row
              no-gutters
              wrap
              justify="center"
              align="center"
              class="mb-2 pb-2"
            >
              <v-col cols="6" v-if="$vuetify.breakpoint.smAndUp">
                <v-btn
                  block
                  tile
                  :outlined="isUpload == true ? true : false"
                  @click="isUpload = false"
                  depressed
                  color="primary"
                >
                  <v-icon>mdi-calendar</v-icon>PILIH ANGGOTA AKTIF
                </v-btn>
              </v-col>
              <v-col cols="6" v-if="$vuetify.breakpoint.smAndUp">
                <v-btn
                  block
                  tile
                  :outlined="isUpload == true ? false : true"
                  @click="isUpload = true"
                  depressed
                  color="primary"
                >
                  <v-icon>mdi-calendar</v-icon>UNGGAH FILE ANGGOTA
                </v-btn>
              </v-col>
              <v-col cols="12" sm="12" md="12" lg="12" v-else>
                <v-radio-group v-model="isUpload">
                  <v-radio label="Pilih Anggota" :value="false"></v-radio>
                  <v-radio label="Unggah File Anggota" :value="true"></v-radio>
                </v-radio-group>
              </v-col>
            </v-row>
            <template v-if="!isUpload">
              <v-alert outlined :type="sisaKuota < 0 ? 'error' : 'info'" text>
                <template v-slot:default>
                  <div
                    v-if="sisaKuota < 0 && current_organisasi.kuota_plotting"
                  >
                    Anda telah mengaktifkan {{ userTerpilih.length }} Anggota
                    sedangkan Anda hanya memiliki
                    {{ current_organisasi.kuota_plotting.kuota }} Kuota, silakan
                    non aktifkan
                    {{
                      userTerpilih.length -
                        current_organisasi.kuota_plotting.kuota
                    }}
                    anggota untuk dapat melakukan proses selanjutnya.
                  </div>
                  <div v-else>
                    Pilih Anggota yang akan Anda aktifkan berikut ini
                  </div>
                </template>
              </v-alert>
              <br />
              <v-row>
                <v-col cols="12" sm="12" md="6" lg="6">
                  <v-card outlined class="pa-2">
                    <v-row>
                      <v-col cols="6" class="title" justify="center">
                        Pilih Anggota
                        <p class="mt-0 pt-0 caption grey--text" v-if="page">
                          {{ page.total }} Anggota
                        </p>
                      </v-col>
                      <v-col cols="6">
                        <v-text-field
                          autofocus
                          dense
                          append-icon="mdi-magnify"
                          single-line
                          outlined
                          label=""
                          v-model="textSearch"
                          @click:append="getUser"
                          @keyup.enter="getUser"
                          hide-details
                        ></v-text-field
                      ></v-col>
                    </v-row>

                    <v-data-table
                      v-model="userTerpilih"
                      :headers="headers"
                      :items="users"
                      :items-per-page="10"
                      item-key="user_id"
                      show-select
                      hide-default-footer
                    >
                      <template v-slot:body="{ items }">
                        <tbody>
                          <tr v-for="item in items" :key="item.user_id">
                            <td>
                              <v-checkbox
                                v-model="userTerpilih"
                                :value="item"
                                style="margin:0px;padding:0px"
                                hide-details
                              />
                            </td>
                            <td>
                              <p class="mb-0 pb-0">{{ item.nama }}</p>
                              <p class="mt-0 pt-0 grey--text">
                                {{ item.email }}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                      <template v-slot:footer>
                        <v-row wrap v-if="page">
                          <v-col
                            cols="9"
                            v-if="page && $vuetify.breakpoint.smAndUp"
                            class="text-center"
                          >
                            <v-pagination
                              v-if="page.total"
                              :key="page_key"
                              v-model="current_page"
                              :length="page.last_page"
                              :total-visible="7"
                              @input="change"
                            ></v-pagination>
                          </v-col>
                          <v-col
                            :cols="$vuetify.breakpoint.smAndUp ? 3 : 9"
                            v-if="page.from"
                            class="text-right"
                          >
                            <p class="caption font-weight-bold">
                              {{ page.from }} - {{ page.to }} dari
                              {{ page.total }}
                            </p>
                          </v-col>
                        </v-row>
                      </template>
                    </v-data-table>
                  </v-card>
                </v-col>
                <v-col cols="12" sm="12" md="6" lg="6">
                  <v-card outlined class="pa-2">
                    <v-row no-gutters>
                      <v-col
                        cols="8"
                        class="title"
                        justify="center"
                        v-if="
                          current_organisasi &&
                            current_organisasi.kuota_plotting
                        "
                      >
                        Anggota Aktif ({{ userTerpilih.length }}/{{
                          current_organisasi.kuota_plotting.kuota
                        }})
                        <p class="mt-0 pt-0 caption grey--text" v-if="page">
                          Anggota yang akan diaktifkan diperiode perpanjangan
                        </p>
                      </v-col>
                      <v-col cols="4" align="right">
                        <m-button
                          class="ma-2 mt-n1"
                          mode-text
                          text="Batal"
                          icon="mdi-close"
                          :large="false"
                          color="red"
                          action="close"
                          @close="userTerpilih = []"
                        ></m-button>
                      </v-col>
                    </v-row>
                    <v-data-table
                      v-if="userTerpilih.length > 0"
                      :headers="headersTerpilih"
                      :items="userTerpilih"
                      :items-per-page="10"
                      sort-by="nama"
                    >
                      <template v-slot:body="{ items }">
                        <tbody>
                          <tr v-for="item in items" :key="item.user_id">
                            <td width="50">
                              <v-checkbox
                                :on-icon="'mdi-close'"
                                color="red"
                                v-model="userTerpilih"
                                :value="item"
                                style="margin:0px;padding:0px"
                                hide-details
                              />
                            </td>
                            <td>
                              <p class="mb-0 pb-0">{{ item.nama }}</p>
                              <p class="mt-0 pt-0 grey--text">
                                {{ item.email }}
                              </p>
                            </td>
                          </tr>
                        </tbody>
                      </template>
                    </v-data-table>
                    <v-alert class="mt-12" v-else outlined type="error" text>
                      <template v-slot:default>
                        Belum ada anggota terpilih
                      </template>
                    </v-alert>
                  </v-card>
                </v-col>
              </v-row>
            </template>

            <template v-else>
              <v-alert outlined type="info" text>
                <template v-slot:default>
                  <v-row no-gutters>
                    <v-col cols="12" sm="12" md="9" lg="9">
                      Untuk pilih anggota aktif menggunakan excel, maka unduh
                      template file excel berikut ini.</v-col
                    >
                    <v-col cols="12" sm="12" md="3" lg="3">
                      <m-button
                        small
                        color="info"
                        icon="mdi-download"
                        text="Unduh Template"
                        action="onDownload"
                        @onDownload="onDownload('xlsx')"
                      ></m-button>
                    </v-col>
                  </v-row>
                </template>
              </v-alert>
              <v-alert
                v-if="sisaKuota < 0 && current_organisasi.kuota_plotting"
                outlined
                type="error"
                text
              >
                <template v-slot:default>
                  Anda telah mengaktifkan {{ userTerpilih.length }} Anggota
                  sedangkan Anda hanya memiliki
                  {{ current_organisasi.kuota_plotting.kuota }} Kuota, silakan
                  non aktifkan
                  {{
                    userTerpilih.length -
                      current_organisasi.kuota_plotting.kuota
                  }}
                  anggota untuk dapat melakukan proses selanjutnya.
                </template>
              </v-alert>

              <div class="container">
                <span class="">Unggah File sesuai format yang ditentukan</span>
                <v-file-input
                  prepend-icon="mdi-file-excel"
                  ref="file"
                  v-model="file"
                  persistent-hint
                  hint="Jenis file unggahan dengan format (.xlsx atau .xls) maks 1.5 MB"
                  id="file"
                  @change="onUpload"
                  placeholder="Pilih File (.xlsx atau .xls)"
                  accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                  name="File"
                  data-vv-name="file"
                  data-vv-as="File"
                  v-validate="'required'"
                  :error-messages="errors.collect('form.file')"
                  outlined
                  dense
                ></v-file-input>
              </div>
            </template>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                v-if="current_organisasi.kuota_plotting"
                :disabled="
                  userTerpilih.length > current_organisasi.kuota_plotting.kuota
                "
                color="primary"
                @click="step = 2"
              >
                Lanjut
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-stepper-content>

        <v-stepper-content step="2">
          <v-card flat>
            <v-card-title class="body-1">
              Apakah Anda yakin akan mengaktifkan
              <strong
                >&nbsp; {{ userTerpilih.length }} Anggota berikut ini</strong
              >
            </v-card-title>
            <v-card-text>
              <v-row class="mt-0 mx-0 body-1 black--text grey lighten-4">
                <v-col cols="8">Nama Anggota</v-col>
              </v-row>
              <v-divider></v-divider>
              <v-list class="grey lighten-4" dense>
                <v-list-item
                  class="grey--text"
                  v-for="item in userTerpilih"
                  :key="item.index"
                >
                  <v-list-item-content>
                    <v-list-item-title>
                      <span style="white-space: normal;">{{ item.nama }}</span>
                    </v-list-item-title>
                    <v-list-item-subtitle>
                      <span style="white-space: normal;">{{ item.email }}</span>
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
              <v-divider></v-divider>
              <v-row class="mt-0 mx-0 body-1 black--text grey lighten-4">
                <v-col cols="8">Total Anggota</v-col>
                <v-col cols="4"
                  >{{ userTerpilih.length }} Anggota (tersisa
                  {{ sisaKuota }} kuota)</v-col
                >
              </v-row>

              <v-row no-gutters>
                <v-col cols="12">
                  <v-checkbox
                    v-model="setuju"
                    class="mx-2 pt-4"
                    dense
                    color="teal"
                    name="setuju"
                    label=""
                    data-vv-name="setuju"
                    data-vv-as="Persetujuan"
                    v-validate="'required'"
                    :error-messages="errors.collect('form.setuju')"
                  >
                    <template v-slot:label>
                      <div class="body-2 black--text">
                        Saya yakin akan
                        <strong>menyimpan dan mengaktifkan</strong> Anggota di
                        atas untuk periode yang akan datang
                      </div>
                    </template>
                  </v-checkbox>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-btn text @click="step = 1">
                Kembali
              </v-btn>
              <v-spacer></v-spacer>
              <m-button
                :disabled="!setuju"
                color="info"
                icon="mdi-content-save"
                :text="isEdit ? 'Ubah' : 'Simpan'"
                action="save"
                @save="save"
              ></m-button>
            </v-card-actions>
          </v-card>
        </v-stepper-content>
      </v-stepper>
    </v-container>
    <v-container v-else>
      <v-alert class="mt-12" outlined type="error" text>
        <template v-slot:default>
          Fitur ini tidak dapat digunakan di perangkat Mobile. Untuk mendapatkan
          hasil yang maksimal Silakan lakukan konfigurasi pada perangkat desktop
        </template>
      </v-alert>
    </v-container>
    <ModalInfo ref="modalDlg" title="Berhasil" :info="info" />
  </m-dialog>
</template>

<script>
import ModalInfo from "../../404/pages/m-modal-info";

export default {
  components: {
    ModalInfo
  },
  data() {
    return {
      isUpload: false,
      isEdit: false,
      users: [],
      userTerpilih: [],
      file: null,
      step: 1,
      setuju: false,
      page: null,
      cp: 1,
      pagination: {
        sortBy: "nama"
      },
      current_page: 0,
      jump_page: 0,
      selection: [],
      textSearch: null,
      pagging: {},
      page_key: 0,
      totalPagination: [],
      headers: [{ text: "Nama", align: "left", value: "nama" }],
      headersTerpilih: [
        { text: "", align: "left", value: "nama" },
        { text: "Nama", align: "left", value: "nama" }
      ]
    };
  },
  methods: {
    // eslint-disable-next-line
    open(obj) {
      this.step = 1;
      this.$validator.reset();
      this.setuju = false;
      this.getUserTerpilih();
      this.getUser();

      return this.$refs.dlg.open();
    },

    onDownload() {
      this.$store
        .dispatch("user/getTemplatePlotting", this.organisasi_id)
        .then(url => {
          window.open(url, "_blank");
        });
    },

    // @vuese
    // get daftar user organisasi
    getUser() {
      this.$store
        .dispatch("user/get", {
          organisasi_id: this.organisasi_id,
          params: {
            is_aktif: 1,
            user_plot: false,
            order_by_nama: true,
            page: this.cp,
            keyword: this.textSearch
          }
        })
        .then(res => {
          this.page = res.data;
          this.users = [...res.data.data];
        })
        .catch(e => e);
    },

    // @vuese
    // simpan array userTerpilih ke store user/plotting
    save() {
      this.$validator
        .validateAll("form")
        .then(res => {
          if (!res) return Promise.reject();
          return res;
        })
        .then(() => {
          const user_ids = [];
          this.userTerpilih.forEach(item => {
            user_ids.push(item.user_id);
          });
          if (
            this.current_organisasi &&
            this.current_organisasi.kuota_plotting
          ) {
            return this.$store.dispatch("user/plotting", {
              organisasi_id: this.organisasi_id,
              obj: {
                kuota_id: this.current_organisasi.kuota_plotting.kuota_id,
                ids: user_ids
              }
            });
          }
        })
        .then(res => {
          if (res) {
            this.$refs.dlg.resolve();
            this.toModalInfo();
            this.loadOrganisasi();
          }
          return res;
        })
        .catch(e => e);
    },

    // eslint-disable-next-line
    toModalInfo() {
      this.$refs.modalDlg.open().then(() => {});
    },

    loadOrganisasi() {
      this.$store
        .dispatch("organisasi/switchOrganisasi", this.organisasi_id)
        .catch(e => e);
    },

    // @vuese
    // get user yang telah dipilih untuk diaktifkan diperiode berikutnya
    getUserTerpilih() {
      this.$store
        .dispatch("user/getUserTerpilih", {
          organisasi_id: this.organisasi_id
        })
        .then(res => {
          this.userTerpilih = [...res.data];
          if (this.userTerpilih.length > 0) {
            this.isEdit = true;
          }
        })
        .catch(e => e);
    },

    change() {
      if (this.current_page !== this.page.current_page) {
        this.cp = this.current_page;
        this.getUser();
      }
    },

    // @vuese
    // upload file daftar user terpilih untuk diaktifkan diperiode berikutnya
    onUpload() {
      if (this.file) {
        this.messages = [];

        const params = {
          organisasi_id: this.organisasi_id,
          file: this.file
        };

        this.$store.dispatch("user/plottingUser", params).then(res => {
          this.userTerpilih = [];
          this.userTerpilih = res.data;
        });
      }
    }
  },
  computed: {
    info() {
      if (this.current_organisasi && this.current_organisasi.kuota_plotting) {
        var startAt = this.$options.filters.toD(
          this.current_organisasi.kuota_plotting.start_at
        );
        var sumUser =
          this.current_organisasi.kuota_plotting.kuota -
          this.userTerpilih.length;

        var i = `Terima kasih, Anda telah mengaktifkan <b>${this.userTerpilih.length}</b>, Anda memiliki <b>${sumUser} kuota tersisa</b>. Jika Anda ingin ubah plotting Anggota Aktif sebelum  <b>${startAt}</b>. Menu ubah ploting tersebut terletak dihalaman beranda. `;
        return i;
      }
    },
    sisaKuota() {
      if (this.current_organisasi && this.current_organisasi.kuota_plotting) {
        var sumUser =
          this.current_organisasi.kuota_plotting.kuota -
          this.userTerpilih.length;
        return sumUser;
      }
    }
  },
  watch: {
    page(n) {
      if (n) {
        this.current_page = n.current_page;
        this.jump_page = n.current_page;
        this.page_key = Math.random();
        for (let i = 1; i <= n.last_page; i++) {
          this.totalPagination.push(i);
        }
      }
    },
    users() {
      this.current_page = this.page ? this.page.current_page : 0;
    }
  }
};
</script>
<style scoped>
.v-list {
  height: 200px;
  overflow-y: auto;
}
</style>
